import React, { forwardRef, ReactNode } from 'react';
import { ScaleFade as ChakraScaleFade, ScaleFadeProps } from '@chakra-ui/react';

interface Props extends Omit<ScaleFadeProps, `css`> {
  children: ReactNode;
}

export const ScaleFade = forwardRef<HTMLDivElement, Props>(
  ({ children, ...props }, ref): JSX.Element => {
    return (
      <ChakraScaleFade ref={ref} {...props}>
        {children}
      </ChakraScaleFade>
    );
  }
);

export type { Props as ScaleFadeProps };
